import { Forward, Mail, MessageSquare, Reply } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { ChannelPill } from './channel-pill';
import { ComposerHeader } from './composer-header';
import type { ComposerMode } from '../types';

type ModeSelectorProps = {
  mode: ComposerMode;
  onClose?: () => void;
};

/** What the composer was opened as. It is stated, not chosen: whoever opened it
 *  already answered that, and offering the choice again asks it twice. */
export function ModeSelector({ mode, onClose }: ModeSelectorProps) {
  const { t } = useTranslation('mailbox');

  if (mode === 'reply' || mode === 'forward') {
    const Icon = mode === 'reply' ? Reply : Forward;

    return (
      <ComposerHeader onClose={onClose}>
        <span className="flex items-center gap-2 px-3 text-sm font-medium text-foreground">
          <Icon className="size-4" strokeWidth={2.5} />
          {mode === 'reply' ? t('Reply') : t('Forward')}
        </span>
      </ComposerHeader>
    );
  }

  return (
    <ComposerHeader onClose={onClose}>
      <ChannelPill active icon={Mail} label={t('Email')} className="h-10" />
      <ChannelPill
        disabled
        icon={MessageSquare}
        label={t('SMS')}
        className="h-10"
      />
    </ComposerHeader>
  );
}
